import Thumbnail from 'components/Thumbnail'
import { useCollectiveContext } from 'context/CollectiveContext'
import CollectivePageHeader from '../Common/CollectivePageHeader/CollectivePageHeader'
import NoticeRouter from './NoticeRouter'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconProp } from '@fortawesome/fontawesome-svg-core'

interface IProps {
  header?: string
  icon?: IconProp
  subheader?: string
  children?: React.ReactNode
}

function TokenGate({
  header = 'Token Holders Only, Please',
  subheader = 'This screen is only visible to members with tokens of this DAO.',
  icon,
  children
}: IProps) {
  const { collective, demoMode } = useCollectiveContext()

  if (
    demoMode ||
    (collective.membership?.approved &&
      collective.membership.totalTokens !== '0')
  ) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <>{children}</>
  }

  return (
    <div className="bg-white shadow mb-4 rounded-lg">
      <CollectivePageHeader collective={collective} />

      <div className="p-4 space-y-4">
        <div className="bg-gray-50 p-5 rounded-lg">
          <div className="flex flex-col gap-4 justify-center items-center">
            {icon ? (
              <FontAwesomeIcon icon={icon} size="4x" color="gray" />
            ) : (
              <>
                <Thumbnail
                  src={collective.thumb}
                  initials={collective.name.substring(0)}
                  className="h-16 w-16 rounded-full overflow-hidden"
                />
                <h3 className="text-xl text-gray-700 pt-4">{header}</h3>
              </>
            )}

            <p className="text-md font-light text-gray-700 text-center pt-4 pb-10">
              {subheader}
            </p>

            <NoticeRouter />
          </div>
        </div>
      </div>
    </div>
  )
}

export default TokenGate
